export default function (phone) {
  return phone.replace(/([^+\d])/gi, '')
}
